import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../i18n/LanguageContext';

const BannerContainer = styled.div<{ $imageUrl?: string }>`
  position: relative;
  background-color: var(--bg-secondary);
  padding: ${props => props.$imageUrl ? '6rem 0' : '1.5rem 0'};
  text-align: center;
  border-bottom: 1px solid var(--border-color);
  background-image: ${props => props.$imageUrl ? `url(${props.$imageUrl})` : 'none'};
  background-size: cover;
  background-position: center;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
`;

const BannerText = styled.h3<{ $hasImage?: boolean }>`
  font-size: ${props => props.$hasImage ? '2.5rem' : '1.2rem'};
  text-transform: uppercase;
  letter-spacing: 2px;
  color: ${props => props.$hasImage ? 'white' : 'var(--text-secondary)'};
  position: relative;
  z-index: 2;
  margin: 0;
  font-weight: ${props => props.$hasImage ? '600' : '500'};
`;

interface HeaderBannerProps {
  textKey?: string;
  title?: string;
  imageUrl?: string;
}

const HeaderBanner: React.FC<HeaderBannerProps> = ({ textKey, title, imageUrl }) => {
  const { t } = useLanguage();
  
  // Use title if provided, otherwise use translation
  const displayText = title || (textKey ? t(textKey) : '');

  return (
    <BannerContainer $imageUrl={imageUrl}>
      {imageUrl && <Overlay />}
      <BannerText $hasImage={!!imageUrl}>
        {displayText}
      </BannerText>
    </BannerContainer>
  );
};

export default HeaderBanner; 